export const statusLabelVariants = {
  ACTIVE: { background: '#F2C94C' },
  FINISHED: { background: '#27AE60' },
  CANCELLED: { background: '#DE1616' },
  IN_PROGRESS: { background: '#264FEC' }
}

export const NO_TOKEN_COLORS = {
  RED: '#DE1616',
  BLUE: '#264FEC',
  GRAY: '#CFCED3'
}

export const colorLabel = {
  width: '4px',
  height: '24px',
  borderRadius: '4px'
}

export const linkAction = {
  fontSize: '$md',
  color: '#264FEC',
  cursor: 'pointer'
}

export const finisheCampaignAction = {
  disabled: {
    cursor: 'not-allowed',
    fontSize: '$md'
  },
  able: {
    cursor: 'pointer',
    fontSize: '$md'
  }
}
